import AsyncStorage from '@react-native-async-storage/async-storage';
const LocalStorage = AsyncStorage;
export { LocalStorage };
